export const ACTION_SWAP_ORDER = "ACTION_SWAP_ORDER";

export interface ActionSwapOrder {
  readonly type: typeof ACTION_SWAP_ORDER;
}

export default (): ActionSwapOrder => ({ type: ACTION_SWAP_ORDER });
